<script setup lang="ts">
import { getWidgetVisualIcon } from '@/lib/chart-helpers';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
import ConnxButton from './ConnxButton.vue';
import { AdminWidget } from '@/interfaces/Dashboard';

defineProps<{ widget: AdminWidget; selected: boolean }>();

const emit = defineEmits(['open:settings', 'open:help', 'open:preview']);
</script>
<template>
  <div
    class="tw-relative tw-group hover:tw-ring-2 hover:tw-ring-connx-primary tw-cursor-pointer tw-w-full tw-rounded-md tw-px-8 tw-py-5 tw-bg-connx-white tw-shadow-lg tw-border tw-border-solid tw-border-connx-grey-tint-80"
    :class="{
      'tw-ring-2 tw-ring-connx-primary': selected,
    }"
  >
    <div class="tw-absolute tw-right-1 tw-top-1 tw-flex">
      <connx-button
        title="Preview Widget"
        button-style="blank"
        class="!tw-rounded-lg tw-hidden group-hover:tw-block tw-text-connx-grey-shade-20 tw-shadow-sm"
        @click="emit('open:preview')"
      >
        <connx-icon class="tw-h-5 tw-flex-shrink-0" name="far fa-eye" title="Preview"></connx-icon>
      </connx-button>
      <connx-button
        title="Help"
        v-if="widget.helpFieldText"
        button-style="blank"
        class="!tw-rounded-lg tw-hidden group-hover:tw-block tw-text-connx-grey-shade-20 tw-shadow-sm"
        @click="emit('open:help')"
      >
        <connx-icon class="tw-h-5 tw-flex-shrink-0" name="far fa-question-circle" title="Help Text"></connx-icon>
      </connx-button>
      <connx-button
        title="Change widget settings"
        button-style="blank"
        class="!tw-rounded-lg tw-hidden group-hover:tw-block tw-text-connx-grey-shade-20 tw-shadow-sm"
        @click="emit('open:settings')"
      >
        <ConnxIcon name="far fa-cog" class="tw-h-5"></ConnxIcon>
      </connx-button>
    </div>
    <div @click="emit('open:settings')">
      <div class="tw-flex tw-gap-x-4 tw-mb-4">
        <div
          class="tw-w-14 tw-h-14 tw-border-solid tw-border tw-rounded-md tw-p-3 tw-flex tw-items-center tw-justify-center tw-bg-connx-grey-tint-85 tw-text-connx-grey-shade-20 svg-full tw-flex-shrink-0"
        >
          <connx-icon
            class="tw-w-auto tw-text-connx-primary"
            :name="getWidgetVisualIcon(widget).icon"
            :class="getWidgetVisualIcon(widget).class"
          />
        </div>
        <div class="tw-w-full">
          <div class="tw-flex tw-gap-x-4 tw-justify-between tw-items-start tw-w-full">
            <h5 class="tw-font-normal tw-break-word">{{ widget.widgetName }}</h5>

            <div
              class="tw-shrink-0 tw-w-3 tw-h-3 tw-rounded-full"
              :class="{
                'tw-bg-connx-success': widget.isInUse,
                'tw-bg-connx-danger': !widget.isInUse,
              }"
            ></div>
          </div>
          <p class="tw-mb-0 tw-break-word">{{ widget.subtitle }}</p>
        </div>
      </div>
      <div class="tw-flex tw-gap-x-4 tw-break-word">
        <div v-html="widget.longDescription"></div>
      </div>
    </div>
  </div>
</template>
